"use client";

import ButtonLink from "@/components/_ui/Buttons/ButtonLink/ButtonLink";
import Typography from "@/components/_ui/Typography/Typography";
import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";

export default function GlobalError({
    error,
}: {
  error: Error & { digest?: string };
}) {
    useEffect(() => {
        Sentry.captureException(error);
    }, [error]);

    return (
        <html>
            <body>
                <div className='flex flex-col justify-between space-y-100 max-w-small' id="errorPage">
                    <Typography as="p" variant="subTitle" color="quiet" size={1000}>500</Typography>
                    <div>
                        <Typography as="h1" variant='heading' size={300}>There was an error with the application.</Typography>
                        <Typography as="p" variant='paragraph'>You can either return to the homepage, or contact our support team directly to assist with your enquiry.</Typography>
                    </div>
                    <div className="flex gap-100">
                        <ButtonLink href="/">Back to homepage</ButtonLink>
                        <ButtonLink variant="primaryBorder" href="/">Contact support</ButtonLink>
                    </div>
                </div>
            </body>
        </html>
    );
}
